import FeedbackDispatcher 	from '../dispatcher/FeedbackDispatcher';
import FeedbackConstants    from '../constants/FeedbackConstants';

var FeedbackActions = {

	loadFeedback 	: 	function() {

		FeedbackDispatcher.dispatch({

			actionType 	: 	FeedbackConstants.LOAD_MY_FEEDBACK
		})
	},

	storeFeedback : function( feedback ) {

		FeedbackDispatcher.dispatch({

			actionType 	: 	FeedbackConstants.STORE_FEEDBACK,
			data 		: 	feedback
		})
	},

	acknowledgeItem : function( itemKey ) {

		FeedbackDispatcher.dispatch({

			actionType 	: 	FeedbackConstants.ACKNOWLEDGE_ITEM,
			data 		: 	itemKey
		})
	}
};

export default FeedbackActions;


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/actions/FeedbackActions.js